import api from 'api';

export const loadAffiliates = api(
  'GET /api/spend-adjustments/filters/affiliates'
);
export const loadApplications = api(
  'GET /api/spend-adjustments/filters/applications'
);
export const loadNetworks = api('GET /api/spend-adjustments/filters/networks');
export const loadClusters = api('GET /api/spend-adjustments/filters/clusters');
export const loadPlatforms = api(
  'GET /api/spend-adjustments/filters/platforms'
);
export const loadStatuses = api('GET /api/spend-adjustments/filters/statuses');
export const loadCreatedBy = api(
  'GET /api/spend-adjustments/filters/created-by'
);
export const loadActionTypes = api(
  'GET /api/spend-adjustments/filters/action-types'
);
export const loadTypes = api('GET /api/spend-adjustments/filters/types');
export const loadReasons = api('GET /api/spend-adjustments/filters/reasons');
